import { render } from "./EditProfile.vue?vue&type=template&id=4299ad8c"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=4299ad8c&lang=css"
script.render = render

export default script